import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
  /**
   * Specify your server-side environment variables schema here. This way you can ensure the app
   * isn't built with invalid env vars.
   */
  server: {
    NODE_ENV: z.enum(["development", "test", "production"]),
    APP_LOCALE: z.enum(["en", "de", "es"]),

    /**
     * ODOO database name
     */
    DATA_SOURCE: z.enum(["odoo"]).default("odoo"),
    ODOO_FRONTEND_USER: z.string().nonempty(),
    ODOO_FRONTEND_USER_PASSWORD: z.string().nonempty(),
    ODOO_BACKEND_HOST: z.string().nonempty().default("http://127.0.0.1:8069"),
    PINO_LOG_LEVEL: z.enum(["debug", "info", "warn", "error"]).default("info"),
    PINO_PRETTY: z.coerce.boolean().default(false),
    COMPANY_NAME: z.string().nonempty().default("YourCompanyName"),

    /**
     * PostHog Analytics - Runtime control
     * Set to "false" to disable, "true" or unset to enable
     */
    ENABLE_POSTHOG: z.string().optional().default("false"),
    ENABLE_GUARD: z.string().optional().default("true"),

    /**
     * Turbopack filesystem cache for builds
     * Set to "true" to enable filesystem caching for `next build`
     */
    ENABLE_TURBOPACK_FILESYSTEM_CACHE_FOR_BUILD: z
      .string()
      .optional()
      .default("false"),

    /**
     * Stripe publishable key for payment processing
     */
    STRIPE_PUBLISHABLE_KEY: z.string().nonempty(),
  },

  /**
   * Specify your client-side environment variables schema here. This way you can ensure the app
   * isn't built with invalid env vars. To expose them to the client, prefix them with
   * `NEXT_PUBLIC_`.
   */
  client: {
    // NEXT_PUBLIC_CLIENTVAR: z.string(),
    NEXT_PUBLIC_BASE_PATH: z.string().optional().default(""),
    NEXT_PUBLIC_POSTHOG_KEY: z.string().optional(),
    NEXT_PUBLIC_POSTHOG_HOST: z.string().optional(),
  },

  /**
   * You can't destruct `process.env` as a regular object in the Next.js edge runtimes (e.g.
   * middlewares) or client-side so we need to destruct manually.
   */
  runtimeEnv: {
    NODE_ENV: process.env.NODE_ENV,
    APP_LOCALE: process.env.APP_LOCALE,
    /**
     * ODOO database name
     */
    DATA_SOURCE: process.env.DATA_SOURCE,
    NEXT_PUBLIC_BASE_PATH: process.env.NEXT_PUBLIC_BASE_PATH || "",
    NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
    NEXT_PUBLIC_POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    ODOO_FRONTEND_USER: process.env.ODOO_FRONTEND_USER,
    ODOO_FRONTEND_USER_PASSWORD: process.env.ODOO_FRONTEND_USER_PASSWORD,
    ODOO_BACKEND_HOST: process.env.ODOO_BACKEND_HOST,
    PINO_LOG_LEVEL: process.env.PINO_LOG_LEVEL,
    PINO_PRETTY: process.env.PINO_PRETTY,
    COMPANY_NAME: process.env.COMPANY_NAME,
    ENABLE_POSTHOG: process.env.ENABLE_POSTHOG,
    ENABLE_GUARD: process.env.ENABLE_GUARD,
    ENABLE_TURBOPACK_FILESYSTEM_CACHE_FOR_BUILD:
      process.env.ENABLE_TURBOPACK_FILESYSTEM_CACHE_FOR_BUILD,
    STRIPE_PUBLISHABLE_KEY: process.env.STRIPE_PUBLISHABLE_KEY,
  },
  /**
   * Run `build` or `dev` with `SKIP_ENV_VALIDATION` to skip env validation. This is especially
   * useful for Docker builds.
   */
  skipValidation: !!process.env.SKIP_ENV_VALIDATION,
  /**
   * Makes it so that empty strings are treated as undefined. `SOME_VAR: z.string()` and
   * `SOME_VAR=''` will throw an error.
   */
  emptyStringAsUndefined: false,
});
